import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
function Stars({
  label
}: {
  label: string;
}) {
  return <span className="flex items-center gap-0.5" role="img" aria-label={label} data-id="element-162" data-mp="3kr5t64yb13k8">
      {Array.from({
      length: 5
    }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-163" data-mp="3b0uebnd319yk" data-mpi={index} />)}
    </span>;
}
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="w-full bg-ink" data-id="element-164" data-mp="36zqz932uzhye">
      <div className="mx-auto max-w-content px-5 py-16 lg:py-24" data-id="element-165" data-mp="31zcze8bevebg">
        <div className="flex flex-wrap items-end justify-between gap-5" data-id="element-166" data-mp="3229024en8h3l">
          <h2 id="testimonios" className="max-w-xl font-display text-3xl text-cream sm:text-4xl" data-id="element-167" data-mp="2x11t27kbrlxz">
            Lo que dicen los terapeutas que ya usan el método
          </h2>
          <div className="flex items-center gap-3" data-id="element-168" data-mp="v8dmbo8h2gdg">
            <Stars label="Calificación 4.9 de 5" data-id="element-169" data-mp="qac415ivel31" />
            <p className="text-[13px] text-muted" data-id="element-170" data-mp="qbn7f48elqtm">
              <span className="font-semibold text-cream" data-id="element-171" data-mp="h5y7wcgvp92k">4.9/5</span> · Más de 500
              terapeutas capacitados
            </p>
          </div>
        </div>

        <ul className="mt-12 grid gap-5 lg:grid-cols-3" data-id="element-172" data-mp="m6ch3xu7up26">
          {testimonials.map(item => <li key={item.name} className="flex h-full flex-col rounded-2xl border border-line bg-ink-raised p-7" data-id="element-173" data-mp="7926eqpedn7i">
              <Stars label="5 de 5 estrellas" data-id="element-174" data-mp="c73rfh6dvwlm" />
              <blockquote className="mt-5 font-display text-xl leading-snug text-cream" data-id="element-175" data-mp="zvweeo512u43">
                “{item.quote}”
              </blockquote>
              <footer className="mt-auto pt-6 text-[13px] text-muted" data-id="element-176" data-mp="14uzh41xjco8w">
                <span className="font-semibold text-cream" data-id="element-177" data-mp="q5lav2p9amxq">{item.name}</span> · {item.role}
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}